import {HIDE_MODAL} from "../types";

export default () => {
    return ({type: HIDE_MODAL});
};